<template>
  <TsSection>
    <TsSection containerClass="px-0">
      <TsBreadcrumb :data="breadcrumb" dataTestid="advices-listing-page-breadcrumb" />
      <TsTitle :title= 'useTranslation("Blog-tips&Advice" , "Tips & Advies")' />
      <TsTypography
        >{{useTranslation("Blog-proCardPerks" , "Pro-kaarthouders worden uitgenodigd voor exclusieve evenementen en trainingen bij Toolstation. Deze bieden netwerkmogelijkheden, nieuwe productinzichten, branchetrends en waardevolle vaardigheden, waardoor vakmensen op de hoogte blijven en hun professionele netwerk uitbreiden.")}}
      </TsTypography>
    </TsSection>

    <TsColumn append-class="max-w-max ml-auto">
      <div class="flex items-center gap-8 max-w-max ml-auto justify-between">
        <TsSelectBox
          v-if="sortingByDateOptions.length"
          append-class="rounded-md w-full"
          input-class="w-32"
          :options="sortingByDateOptions"
          optionLabel="name"
          optionValue="value"
          outlined
          :placeholder='useTranslation("sortByDate" , "Sorteer op datum")'
          v-model="selectedDateOrder"
          @select="onSelectLocale"
          :value="selectedDateOrderName"
          @change="updateSelectedDateOrder"
          dataTestid="blogs-select-categories"
        />
      </div>
    </TsColumn>

    <TsTypography v-if="!advicesData?.length" align="center" dataTestid="advices-no-record"
      >{{useTranslation('noResultFound','Geen gegevens gevonden.')}}</TsTypography
    >

    <div v-else-if="isAdvicesFetchInProgress" class="loading-spinner-large"></div>

    <TsGrid v-else :rows="1" :cols="3" :spaceX="4"  append-class="py-5">
      <div v-for="el in advicesData" :key="el.id">
        <TsAdvicesCard
          :data="el.data"
          :date="el.createdDate"
          dataTestid="news-news-and-advice-card"
        />
      </div>
    </TsGrid>

    <TsRow class="justify-center mt-2" v-if="builderStore.advices?.length">
      <TsPagination
        :dataLength="builderStore.advices?.length"
        type="normal"
        :offset="limit"
        :activePageNumber="currentPage"
        @change="changeActivePage"
        @prev="changeActivePage"
        @next="changeActivePage"
        @first="changeActivePage"
        @last="changeActivePage"
      />
    </TsRow>
  </TsSection>
</template>

<script setup lang="ts">
import {useTranslation} from "~/composables/useTranslation";

const TsBreadcrumb = defineAsyncComponent(() => import('~/components/molecules/TsBreadcrumb.vue'));
const TsSelectBox = defineAsyncComponent(() => import('~/components/atoms/TsSelectBox.vue'));
const TsAdvicesCard = defineAsyncComponent(() => import('~/components/organisms/TsAdvicesCard.vue'));
const TsPagination = defineAsyncComponent(() => import('~/components/molecules/TsPagination.vue'));
const TsGrid = defineAsyncComponent(() => import('~/components/organisms/TsGrid.vue'));

const builderStore = useBuilderStore();
const currentPage = ref(1);
const route = useRoute();

const sortingByDateOptions = [
  {
    name: "Ascending",
    value: "ascending",
  },

  {
    name: "Descending",
    value: "descending",
  },
];

const initialDateOrder = sortingByDateOptions.some(
  (option) => option.value === route.query.date
)
  ? route.query.date
  : ""; // Default to empty if invalid

const selectedDateOrder = ref(initialDateOrder);

const limit = 6;
const breadcrumb = [
  {
    text: useTranslation('home','Thuis'),
    link: "/",
  },
  {
    text: "Blogs, News & Advices",
    link: "/blogs-news-advices",
  },
  {
    text: "Advices",
    link: "/advices",
  },
];

useHead({
  title: "Advice | Toolstation",
  meta: [
    {
      name: "description",
      content: "This is the advices listing page of Toolstation.",
    },
  ],
});

const advicesData = ref([]);
const isAdvicesFetchInProgress = ref(false);

const selectedDateOrderName = computed(() => {
  const option = sortingByDateOptions.find(
    (opt) => opt.value === selectedDateOrder.value
  );
  return option ? option.name : ""; // Return name or empty string
});

const updateSelectedDateOrder = async (value) => {
  selectedDateOrder.value = value;
  const dateQuery = new URLSearchParams({
    date: value,
  }).toString();
  await navigateTo(`?${dateQuery}`);
  await fetchAdvices(); // Fetch advices after updating
};

async function filterDate() {

  if (selectedDateOrder.value) {
    const dateQuery = new URLSearchParams({
      date: selectedDateOrder.value,
    }).toString();
    await navigateTo(`?${dateQuery}`);
  }
  isAdvicesFetchInProgress.value = true;
  await builderStore.getAdviceList(
    {},
    selectedDateOrder.value
      ? { createdDate: selectedDateOrder.value === "ascending" ? 1 : -1 }
      : {}
  );
  isAdvicesFetchInProgress.value = true;
  return builderStore?.advices;
}

const fetchAdvices = async (page = 1) => {
  const offset = (page - 1) * limit;
 // await builderStore.getAdviceList();

  let advices = await filterDate();

  if (!Array.isArray(advices)) {
    console.error("Error: advices is not an array", advices);
    return;
  }

  advicesData.value = advices.slice(offset, offset + limit);
  currentPage.value = page;
};

function changeActivePage(page: number) {
  currentPage.value = page;
}

async function onSelectLocale(
  option,
  visibleOptions,
  isLoading,
  searchQuery,
  activeOptionIndex,
  dropdown
) {
  dropdown.hide();
}

watch(currentPage, (newPage) => {
  fetchAdvices(newPage);
});

watch(selectedDateOrder, () => {
  fetchAdvices();
});

await fetchAdvices();
generateSchemaList(advicesData.value, "ItemList", "AdvicesArticle", {
  imageField: "adviceImage",
});
</script>
